// extracted by mini-css-extract-plugin
export default {"skillMain":"Skills_skillMain__hnJwK","chipPart":"Skills_chipPart__7-E0v","textPart":"Skills_textPart__2kCzm","closeBtn":"Skills_closeBtn__HNrjQ"};